<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="categories"
    />
    <h4>子分类</h4>
    <div class="box-table" v-if="data.children && data.children.length">
      <c-source-table
        :table="{ data: data.children }"
        :columns="tableColumns"
        resource="categories"
      />
    </div>
</div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class CategoriesShow extends Vue {
  data = {
    children: []
  }

  get columns() {
    return [
      ...createColumns({
        handleChooseFirstColorProductSuccess: this.fetchData,
        handleDeleteSuccess: () => this.$router.replace({ name: 'categories.index' }),
        action: {
          detail: false
        },
        level: this.data.level
      })
    ]
  }

  get tableColumns() {
    return createColumns({
      handleChooseFirstColorProductSuccess: this.fetchData,
      handleDeleteSuccess: this.fetchData
    })
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    const { category } = await this.$request.get(`/categories/${this.$route.params.id}`);
    this.data = category;
  }
}
</script>
